const TEST_IDENTIFIER = 'basic-table';

const Table: FC = ({ children }) => {
    return (
        <table className="table-styles" data-testid={TEST_IDENTIFIER}>
            {children}
        </table>
    );
};

/* @component */
export default Table;
